import { Pagination, TablePagination } from "@mui/material";
import React from "react";

const EmptyActions = () => null;

const CustomPagination = ({
  total = 0,
  currentPage = 1,
  perPage = 10,
  onPageChange,
}) => {
  const effectiveRowsPerPage = perPage === -1 ? total : perPage;
  const pageCount = Math.ceil(total / effectiveRowsPerPage) || 1;

  const handlePageChange = (event, newPage) => {
    onPageChange(newPage, perPage);
  };

  const handleRowsPerPageChange = (event) => {
    const newRows = parseInt(event.target.value, 10);
    onPageChange(1, newRows === -1 ? total : newRows);
  };

  const rowsPerPageTable = [10, 25, 50]
    .filter((item) => item < total)
    .map((item) => ({
      label: item,
      value: item,
    }));

  rowsPerPageTable.push({
    label: "All",
    value: total,
  });

  return (
    <div className="col-lg-12 flex-column flex-md-row d-flex align-items-center justify-content-center custom-pagination">
      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
        sx={{
          "& .Mui-selected": {
            backgroundColor: "#0CB9B8",
            color: "#fff",
          },
        }}
      />

      <TablePagination
        className="row-per-page-pagination"
        rowsPerPageOptions={rowsPerPageTable}
        component="div"
        count={total}
        rowsPerPage={perPage}
        page={currentPage - 1}
        onPageChange={(e, newPage) => handlePageChange(e, newPage + 1)}
        onRowsPerPageChange={handleRowsPerPageChange}
        ActionsComponent={EmptyActions}
        labelDisplayedRows={({ from, to, count }) => (
          <div className="mt-3">
            {`${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`}
          </div>
        )}
      />
    </div>
  );
};

export default CustomPagination;
